import { ApiBase } from '../apiBase';
import { ApiBusinessBaseBase } from './ApiBusinessBaseBase';
import {
  BusinessBaseRequestOrigin,
  BusinessBaseType,
  MostRequestedBusinessBaseResponse,
  MostSearchedBusinessBaseResponse,
} from './models/BusinessBaseStatisticsModels';

export class ApiBusinessBaseStatistics extends ApiBusinessBaseBase {
  public static statisticsBaseUrl(): string {
    return `${ApiBusinessBaseBase.baseUrl}/stats`;
  }

  public static async mostSearched(params: {
    start_date?: string;
    end_date?: string;
    requested_results?: number;
    value?: string;
    types?: BusinessBaseType[];
  }): Promise<MostSearchedBusinessBaseResponse> {
    const response = await ApiBase.get(
      `${ApiBusinessBaseStatistics.statisticsBaseUrl()}/requests/business_base`,
      {
        start_date: params.start_date,
        end_date: params.end_date,
        requested_results: params.requested_results,
        value: params.value,
        types:
          params.types && params.types.length > 0
            ? params.types.join(',')
            : undefined,
      }
    );

    return response.data.data as MostSearchedBusinessBaseResponse;
  }

  public static async mostRequested(params: {
    start_date?: string;
    end_date?: string;
    requested_results?: number;
    value?: string;
    origin?: BusinessBaseRequestOrigin;
  }): Promise<MostRequestedBusinessBaseResponse> {
    const response = await ApiBase.get(
      `${ApiBusinessBaseStatistics.statisticsBaseUrl()}/requests/business_base/requests`,
      {
        start_date: params.start_date,
        end_date: params.end_date,
        requested_results: params.requested_results,
        value: params.value,
        origin: params.origin,
      }
    );

    return response.data.data as MostRequestedBusinessBaseResponse;
  }
}
